import { render, staticRenderFns } from "./AuthRootView.vue?vue&type=template&id=6610861c&scoped=true"
import script from "./AuthRootView.vue?vue&type=script&lang=ts"
export * from "./AuthRootView.vue?vue&type=script&lang=ts"
import style0 from "./AuthRootView.vue?vue&type=style&index=0&id=6610861c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6610861c",
  null
  
)

export default component.exports